exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg[data-v-5a796c62]{background:url(" + require("../../assets/bg_auth.jpg") + ");opacity:.5;position:absolute;top:0;right:0;bottom:0;left:0}.wrapper[data-v-5a796c62]{display:flex;flex-direction:column;height:100vh;flex:1}.content[data-v-5a796c62]{display:flex;flex-direction:row}.md-card[data-v-5a796c62]{width:480px;padding:20px}.content[data-v-5a796c62]:after,.content[data-v-5a796c62]:before,.wrapper[data-v-5a796c62]:after,.wrapper[data-v-5a796c62]:before{content:\"\";flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5a796c62","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/views/UserPage.vue
// module id = 421
// module chunks = 0